import { SlateResponse } from "../store/types";

export type ExportDataType = string;
export type AppContext = 'Data_Hub' | 'Pre_Contest' | 'Contest_Generator' | 'Late_Swap' | 'Lineup_Builder' | 'Entry_Manager' | 'Single_Lineup_Sim';

interface FilenameOptions {
  selectedSlate: SlateResponse;
  app?: AppContext;
  dataType?: ExportDataType;
  includeExtension?: boolean; // Set to false for GridToolbarExport which adds .csv automatically
}

/**
 * Generates a contextual filename for CSV exports
 * Format: {site}_{sport}_{slateName}_{app}_{dataType}.csv
 * Example: DK_NFL_Main_Data_Hub_Lineups.csv
 */
export const getContextualFilename = (options: FilenameOptions): string => {
  const { selectedSlate, app, dataType, includeExtension = true } = options;

  const parts = [
    selectedSlate.site?.toUpperCase(),
    selectedSlate.sport?.toUpperCase(),
    selectedSlate.name,
    app,
    dataType,
  ].filter(Boolean);

  const filename = parts.join('_').replace(/ /g, '_');
  return includeExtension ? `${filename}.csv` : filename;
};

/**
 * @deprecated Use getContextualFilename instead for more descriptive filenames
 */
export const getFilename = (selectedSlate: SlateResponse, suffix: string = ''): string => {
  return `${selectedSlate.site?.toUpperCase()}_${selectedSlate.sport?.toUpperCase()}_${selectedSlate.name}${suffix}.csv`.replace(/ /g, '_');
};

/**
 * Downloads CSV data as a file using Blob URLs.
 * Works reliably across all browsers including iOS Safari,
 * unlike data URIs used by react-csv which show as "Unknown" on iOS.
 */
export const downloadCsvFile = (data: string, filename: string): void => {
  const blob = new Blob([data], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  setTimeout(() => URL.revokeObjectURL(url), 250);
};